/* eslint-disable no-prototype-builtins */
import { takeEvery } from 'redux-saga/effects';
import type { EffectCreatorParams } from '@app/redux/types';
import { IDENTIFY } from '../consts';

interface IdentifyPayload {
  id?: string | number;
  uuid?: string;
}

export const onIdentify = ({
  payload: { id },
}: EffectCreatorParams<IdentifyPayload>) => {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && window.hasOwnProperty('ga')) {
    window.ga('set', 'userId', id);
  }
};

export default function* identifySaga() {
  yield takeEvery(IDENTIFY, onIdentify);
}
